import { reportSalesTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_SALES_FILTERS, RESTORE_INITIAL } = reportSalesTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
  unit: null,
};

export const reportSalesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_SALES_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState
    default:
      return state;
  }
};